import { component } from "picoapp";
import { type Context, type TablescapeState } from "../../state";
import { TablescapeEvent, TablescapeContext } from "@tablescape/context";

function toggleCart(node: HTMLElement) {
  node.addEventListener("click", () => {
    TablescapeContext.emit(TablescapeEvent.TOGGLE_CART, {
      ui: {
        cartDrawerOpen: true,
        cartDrawerUserToggled: true,
        giftNoteDrawerOpen: false,
        productVariantDrawerOpen: false,
      },
    });
  });

  TablescapeContext.on(
    TablescapeEvent.UPDATE_CART_ITEM_COUNT,
    (data?: TablescapeState) => {
      const cartItemCount = data?.cart?.quantity ?? 0;
      const cartBubble = node.querySelector<HTMLDivElement>(".js-cart-bubble");

      if (cartItemCount) {
        cartBubble?.classList.remove("hidden");

        const cartCountElement = node.querySelector(".js-cart-count");
        const textNode = cartCountElement?.querySelector(
          "[data-tbsp-component='text']"
        );
        if (cartCountElement && textNode) {
          textNode.innerHTML = String(cartItemCount);
        }
      } else {
        cartBubble?.classList.add("hidden");
      }
    }
  );
}

export const cartDrawerToggle = component<Context>((node) => {
  toggleCart(node);
});
